import { render, staticRenderFns } from "./EditPermisosUserModal.vue?vue&type=template&id=c10583ac&scoped=true"
import script from "./EditPermisosUserModal.vue?vue&type=script&lang=js"
export * from "./EditPermisosUserModal.vue?vue&type=script&lang=js"
import style0 from "./EditPermisosUserModal.vue?vue&type=style&index=0&id=c10583ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c10583ac",
  null
  
)

export default component.exports